import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Svg from 'rp-react-svg-icon';
import styles from './submitButton.scss';

const getActiveButtonClass = loading => (
  classNames(
    styles.submit,
    {
      [styles.submitActive]: loading,
    },
  )
);

const SubmitButton = ({
  label, disabled, loading, customProps,
}) => (
  <div className={styles.submitField}>
    <button
      type="submit"
      disabled={disabled}
      className={`${getActiveButtonClass(loading)} ${customProps && customProps.className}`}
        >
      {loading ? (
        <Svg
          iconName="spinner"
          size="Large"
          className="ui-animation_spinnerAnimation"
                />
            ) : label}
    </button>
  </div>
);

SubmitButton.defaultProps = {
  loading: false,
};

SubmitButton.propTypes = {
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default SubmitButton;

